//
// Get media types (source : laravel config/mediatypes.php
const configImageSizes = window.config.imageSizes

export default Object.freeze(configImageSizes)
